import { CinemaFaqDto } from '@cineamo/api/models/cinema-faq/CinemaFaqDto.types';

import { CinemaFaqListResponse } from '@cineamo/api/types/ApiListResponse.types';
import { ApiResponse } from '@cineamo/api/types/ApiResponse.types';

import { API_URL } from '@/constants/http-constants';

import apiClient from '@/utils/api/cineamoApiClient';

import { buildUrlQuery, UrlQueryParameter } from '@/helpers/url-query-helper';

export async function getCinemaFaqById(cinemaFaqId: number): Promise<ApiResponse<CinemaFaqDto> | null> {
    return apiClient.getOrNull<ApiResponse<CinemaFaqDto>>(`/cinema-faqs/${cinemaFaqId}`);
}

export type GetCinemaFaqsQuery = {
    cinemaIds?: number[];
} & UrlQueryParameter;

export async function getCinemaFaqs(params?: GetCinemaFaqsQuery): Promise<ApiResponse<unknown, CinemaFaqListResponse>> {
    return apiClient.get<ApiResponse<unknown, CinemaFaqListResponse>>(
        `${API_URL}/cinema-faqs${buildUrlQuery(params)}`,
        {
            credentials: 'same-origin'
        }
    );
}
